import { Hub, HubManager } from 'src/app/pages/hubs/common/Hubs';
import { HubService } from 'src/app/pages/hubs/common/HubService';
import { Injectable, Attribute, Optional } from '@angular/core';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { CommunicationHub } from './CommunicationHub'; 
import { AgentLiveMoniterService } from '@app/_core/services/agent-live-moniter.service'
let self;
let onvidaWrapper;
@Injectable({ providedIn: 'root' })
export class AgentLiveViewHub extends Hub {
    static START_LIVEVIEW = 'agentLiveViewHubStartLiveView';
    static END_LIVEVIEW = 'agentLiveViewHubEndLiveView';
    static HUB_Name: string = 'AgentLiveViewHub';
    static _hubService;
    static _AgentLiveMoniter;
    constructor(private hubManager: HubManager, private hubService: HubService, private agentLive: AgentLiveMoniterService
    ) {
        super();
        self = this;
        AgentLiveViewHub._hubService = hubService;
        AgentLiveViewHub._AgentLiveMoniter = agentLive;
        hubManager.hubManagerEvents.subscribe((value: any) => {
            if (value && value.eventName == 'CONNECTIONACTIVE') {
                self.join();
            }
        });
    }
    liveView(roomID: string, userID: any, command: string, debug: boolean) {
        //console.log('AgentLiveViewHub.liveView(' + roomID + ', ' + userID + ', ' + command + ')');
        var current = AgentLiveViewHub._hubService.getuserDetails();//self.webStorage.getItemFromSessionStorage('currentUser');
        var currentuserID = self.getByValue(current, 'UserID'); 
        if (userID == currentuserID && AgentLiveViewHub._AgentLiveMoniter.isWrapper()) {
            if (debug) console.log('AgentLiveViewHub.liveView(' + roomID + ', ' + userID + ', ' + command + ')');
            var message = {
                roomID: roomID,
                userID: userID,
                command: command,
                debug: debug
            }
            //AgentLiveViewHub._hubService.setCallEvents({ eventName: 'START_LIVEVIEW', data: message });
            AgentLiveViewHub._AgentLiveMoniter.initializePreview(message); 
        }

    }
    getByValue(data: any, searchValue: string) {
        for (let [key, value] of data.entries()) {
            if (data[key].key == searchValue)
                return data[key].value;
        }
    }

}
